import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { PaperGradientBG } from "../kits";
import VideoCard from "../kits/LayoutKit/VideoCard";
import BlogList from "./BlogList";
import ZenList from "./ZenList";
import CaseList from "./CaseList";
import Courses from "../components/Courses";

const tabOptions = [
  { id: "youtube", label: "YouTube" },
  { id: "blog", label: "Blog" },
  { id: "zendev", label: "Zen Dev" },
  { id: "CaseStudy", label: "Case Studies" },
  { id: "Kurse", label: "Kurse" },
];
const validTabs = tabOptions.map((tab) => tab.id);

const MediaBlog = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getTabFromQuery = () => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    return validTabs.includes(tab) ? tab : "zendev";
  };

  const [activeTab, setActiveTab] = useState(getTabFromQuery);

  useEffect(() => {
    const currentTab = getTabFromQuery();
    if (currentTab !== activeTab) {
      setActiveTab(currentTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (activeTab !== params.get("tab")) {
      params.set("tab", activeTab);
      navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    }

    if (activeTab === "youtube") {
      fetchYoutubeVideos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const [youtubeVideos, setYoutubeVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchYoutubeVideos = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `https://www.googleapis.com/youtube/v3/playlistItems`,
        {
          params: {
            playlistId: "PLXtZktdmGcVe2hLOmekArDhkf12DJ_kvS",
            key: "AIzaSyAeaZWjocSwQ70JMbYk-NU5TrHdVPmv6sk",
            part: "snippet",
            maxResults: 10,
          },
        }
      );

      const validVideos = response.data.items.filter(
        (video) =>
          video.snippet &&
          video.snippet.thumbnails?.high &&
          video.snippet.resourceId?.videoId
      );

      setYoutubeVideos(validVideos);
      setLoading(false);
    } catch (err) {
      console.error("YouTube Fetch Error:", err.response?.data || err.message);
      setError("YouTube Videos konnten nicht geladen werden.");
      setLoading(false);
    }
  };

  const renderContent = () => {
    if (activeTab === "youtube" && loading) {
      return (
        <p className="text-center text-[#EFEBDC]/50 font-mono text-xs">
          <span className="text-[#AC8E66]">$</span> fetch --youtube ... laden...
        </p>
      );
    }

    if (activeTab === "youtube" && error) {
      return (
        <p className="text-center text-red-400/80 font-mono text-xs">
          <span className="text-[#AC8E66]">$</span> error: {error}
        </p>
      );
    }

    switch (activeTab) {
      case "youtube":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {youtubeVideos.map((video) => (
              <VideoCard
                key={video.snippet.resourceId.videoId}
                title={video.snippet.title}
                platform="YouTube"
                content={video.snippet.title}
                mediaUrl={`https://www.youtube.com/watch?v=${video.snippet.resourceId.videoId}`}
                thumbnailUrl={video.snippet.thumbnails.high.url}
              />
            ))}
          </div>
        );
      case "blog":
        return (
          <div className="text-center font-mono text-sm">
            <BlogList />
          </div>
        );
      case "CaseStudy":
        return (
          <div className="text-center font-mono text-sm">
            <CaseList />
          </div>
        );
      case "Kurse":
        return <Courses withPaper={false} />;
      case "zendev":
        return <ZenList />;
      default:
        return null;
    }
  };

  return (
    <PaperGradientBG variant="zenBlack">
      {/* Header */}
      <div className="pt-32 pb-10 px-6">
        <div className="max-w-3xl mx-auto text-center font-mono">
          <p className="text-xs text-[#EFEBDC]/50 mb-3">
            <span className="text-[#AC8E66]">$</span> ls zenlab/
          </p>
          <h1 className="text-xl sm:text-2xl font-bold text-[#EFEBDC]">
            ZenLab
          </h1>
          <p className="text-xs text-[#EFEBDC]/50 mt-2">
            Einblicke, Tipps & Wissen — App Entwicklung & mehr
          </p>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="sticky top-20 z-10 bg-[#171717]/90 backdrop-blur-sm border-b border-[#AC8E66]/20 py-4 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-2">
            {tabOptions.map(({ id, label }) => {
              const isActive = activeTab === id;
              return (
                <button
                  key={id}
                  onClick={() => setActiveTab(id)}
                  className={`px-4 py-2 rounded-md font-mono text-xs transition-all cursor-pointer border ${
                    isActive
                      ? "text-[#EFEBDC] bg-[#232323] border-[#AC8E66]/65 shadow-[inset_0_0_0_1px_rgba(172,142,102,0.35)]"
                      : "text-[#EFEBDC]/50 border-transparent hover:text-[#EFEBDC] hover:bg-[#1c1c1c]/50"
                  }`}
                >
                  {label}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="py-10 px-6">
        <div className="max-w-6xl mx-auto">{renderContent()}</div>
      </div>
    </PaperGradientBG>
  );
};

export default MediaBlog;
